import { render } from "./ticket_details.vue?vue&type=template&id=66b55813&scoped=true"
import script from "./ticket_details.vue?vue&type=script&lang=js"
export * from "./ticket_details.vue?vue&type=script&lang=js"

import "./ticket_details.vue?vue&type=style&index=0&id=66b55813&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b55813"]])

export default __exports__